import * as React from 'react';
import { FC } from 'react';
import { Box, Card as MuiCard, CardContent } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import LocalOfferIcon from '@material-ui/icons/LocalOfferOutlined';
import { FilterList, FilterListItem } from 'react-admin';
import {
    endOfYesterday,
    startOfWeek,
    subWeeks,
    startOfMonth,
    subMonths,
} from 'date-fns';

import TransactionTypes from './TransactionTypes'

const Card = withStyles(theme => ({
    root: {
        [theme.breakpoints.up('sm')]: {
            order: -1,
            width: '15em',
            marginRight: '1em',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
}))(MuiCard);

const Aside: FC = () => {
    const types = TransactionTypes()

    return (
        <Box m="0 0 0 1em" order={-1}>
            <Card>
                <CardContent>
                    {/* <FilterLiveSearch /> */}

                    <FilterList
                        label="resources.Transaction.filters.time"
                        icon={<AccessTimeIcon />}
                    >
                        <FilterListItem
                            label="resources.Transaction.filters.today"
                            value={{
                                'timestamp@_gte': endOfYesterday().toISOString(),
                                'timestamp@_lte': undefined,
                            }}
                        />
                        <FilterListItem
                            label="resources.Transaction.filters.this_week"
                            value={{
                                'timestamp@_gte': startOfWeek(new Date()).toISOString(),
                                'timestamp@_lte': undefined,
                            }}
                        />
                        <FilterListItem
                            label="resources.Transaction.filters.last_week"
                            value={{
                                'timestamp@_gte': subWeeks(
                                    startOfWeek(new Date()),
                                    1
                                ).toISOString(),
                                'timestamp@_lte': startOfWeek(new Date()).toISOString(),
                            }}
                        />
                        <FilterListItem
                            label="resources.Transaction.filters.this_month"
                            value={{
                                'timestamp@_gte': startOfMonth(new Date()).toISOString(),
                                'timestamp@_lte': undefined,
                            }}
                        />
                        <FilterListItem
                            label="resources.Transaction.filters.last_month"
                            value={{
                                'timestamp@_gte': subMonths(
                                    startOfMonth(new Date()),
                                    1
                                ).toISOString(),
                                'timestamp@_lte': startOfMonth(new Date()).toISOString(),
                            }}
                        />
                        <FilterListItem
                            label="resources.Transaction.filters.earlier"
                            value={{
                                'timestamp@_gte': undefined,
                                'timestamp@_lte': subMonths(
                                    startOfMonth(new Date()),
                                    1
                                ).toISOString(),
                            }}
                        />
                    </FilterList>
                    <FilterList
                        label="resources.Transaction.filters.type"
                        icon={<LocalOfferIcon />}
                    >
                        {types.map((type: { name: string, id: string }) => (
                            <FilterListItem
                                label={type.name}
                                key={type.id}
                                value={{ 'type@_eq': type.id }}
                            />
                        ))}
                    </FilterList>
                </CardContent>
            </Card>
        </Box>
    );
}

export default Aside;
